import { forwardRef, useEffect, useImperativeHandle, useRef, useState } from "react";
import { contactDateFormat2 } from "../../../app/common/common-functions/functions";
import { useHistory } from "react-router";
import { CONTACT_CLASS_NAME, LABEL, VIEW_TYPE } from "../constants";
const ContactCard = forwardRef(({
    clickedContactId = 0,
    contactItem = {},
    onClickNewActivity = () => { },
    onClickSendEmail = () => { },
    onUpdateMilestone = () => { },
    onWhatsappClick = () => { },
    pipelines = [],
    provided,
    setClickedContactId = () => { },
    snapshot,
    tagColorFormatter = () => { },
    viewType,

}, ref) => {

    const menuRef = useRef(null);
    const cardRef = useRef(null);

    const pipelineMenuRef = useRef(null);
    const [dropdownPosition, setDropdownPosition] = useState('right');
    const [isSendPipelineMenu, setIsSendPipelineMenu] = useState(false);
    const [isSendStageMenu, setIsSendStageMenu] = useState(false);
    const history = useHistory();
    const {
        cardFlag = "",
        companyName = "",
        contactID = "",
        contactPropertyId = "",
        dialingCode = "",
        diary = {},
        emailAddress = "",
        lastActivity = "",
        name = "",
        phoneNumber = "",
        pipelineId = "",
        requirementOrLead = "",
        requirementType = 0,
        stageId = "",
        stages = [],
        tags = "",
    } = contactItem;

    const [filteredPipeline, setFilteredPipeline] = useState([]);
    const [filteredMilestone, setFilteredMilestone] = useState([]);
    const [clickedPipelineId, setClickedPipelineId] = useState(0);
    const [clickedStageId, setClickedStageId] = useState(0);

    useEffect(() => {
        setFilteredPipeline(pipelines.filter(p => p.pipeline_id !== pipelineId));
        document.addEventListener("mousedown", handleClickOutside);
        return () => {
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, []);
    useEffect(() => {
        calculateDropdownPosition();
        window.addEventListener('resize', calculateDropdownPosition);
        return () => {
            window.removeEventListener('resize', calculateDropdownPosition);
        };
    }, []);

    const getDiaryTime = (diaryDate) => {
        if (!diaryDate) return "N/A";
        return diaryDate.split(" ")[1] + " " + diaryDate.split(" ")[2];
    }
    const getDiaryDate = (diaryDate) => {
        const [day, month, year, time, meridian] = diaryDate.split(/[-\s:]+/);
        const hours = meridian === "PM" && time !== "12" ? parseInt(time) + 12 : time === "12" && meridian === "AM" ? "00" : time;
        const formattedDateStr = `${year}-${month}-${day}T${hours}:00`;
        return contactDateFormat2(formattedDateStr);
    }
    const toggleContextMenu = (contactId) => {
        setClickedContactId(contactId);
        setTimeout(() => {
            calculateDropdownPosition();
        }, 10);
    };
    const handleClickOutside = (event) => {
        if ((menuRef.current && !menuRef.current.contains(event.target))
        ) {
            setClickedContactId(0);
            setIsSendPipelineMenu(false);
            setIsSendStageMenu(false);
            setClickedPipelineId(0);

        }

    };
    const leadRequirementFormatter = (str) => {
        let parts = str.split(" ");
        let formatString = <>
            <strong>{parts[0]}</strong>
            <span>{" " + parts.slice(1).join(" ")}</span>
        </>
        return formatString;
    }

    const onClickNewDiary = () => {
        onClickNewActivity(contactID);
    }
    const handleClickSendPipeline = () => {
        setIsSendPipelineMenu(true);

        //setClickedContactId(contactID);
    }
    const handleClickPipeline = (pipelineID) => {
        var milestone = filteredPipeline.filter(p => p.pipeline_id === pipelineID)[0]?.stages;
        setFilteredMilestone(milestone);
        setClickedPipelineId(pipelineID);
        setIsSendStageMenu(true);
    }
    const handleMilestoneClick = (stageID) => {

        onUpdateMilestone(clickedContactId, clickedPipelineId, stageID);

        setClickedStageId(stageID);
        setIsSendStageMenu(false);
        setIsSendPipelineMenu(false);
        setClickedContactId(0);
        setClickedPipelineId(0);
    }

    const handleClickExternalLink = () => {

        switch (requirementType) {
            case 1:
                history.push('/Contacts/SaveContact?ID=' + contactID + "&Step=5");
                break;
            case 2:
                history.push('/Property/SaveProperty?ID=' + contactPropertyId);
                break;
            default:
                break;
        }

    }

    const handleEventClasses = () => {
        switch (cardFlag) {
            case "Red":
                return CONTACT_CLASS_NAME.NEXT_24_HOURS_EVENT;
            case "Grey":
                return CONTACT_CLASS_NAME.LAST_MONTH_EVENT;
            default:
                return "";
        }
    }

    const calculateDropdownPosition = () => {
        if (menuRef.current) {
            const dropdownRect = menuRef.current.getBoundingClientRect(); // Get the position and dimensions of the dropdown
            const viewportWidth = window.innerWidth; // Total viewport width (including scrollbar)
            const scrollX = window.scrollX; // Horizontal scroll offset

            console.log("Viewport Width:", viewportWidth);
            console.log("Horizontal Scroll Offset:", scrollX);
            console.log("Dropdown Rect:", dropdownRect);

            // Calculate the total available space to the right of the dropdown
            const spaceToRight = viewportWidth - dropdownRect.right - scrollX;
            const spaceToLeft = dropdownRect.left - scrollX;

            console.log("Space to Right:", spaceToRight);
            console.log("Space to Left:", spaceToLeft);

            // Decide dropdown position
            if (spaceToRight < dropdownRect.width && spaceToLeft >= dropdownRect.width) {
                console.log("Opening dropdown to the left.");
                setDropdownPosition("right");
            } else {
                console.log("Opening dropdown to the right.");
                setDropdownPosition("left");
            }
        }
    };



    return (
        <>

            <div
                className={viewType == VIEW_TYPE.LIST ? "" : "card " + handleEventClasses()}
                {...provided.draggableProps}
                {...provided.dragHandleProps}
                ref={provided.innerRef}
            >
                {(viewType === VIEW_TYPE.CARD_SUMMARY || viewType === VIEW_TYPE.CARD_FULL) &&
                    <>

                        <div className="card-header" ref={cardRef}>

                            <div className="row">
                                <div className="col-md-12">

                                    <div style={{
                                        display: "flex",
                                        alignItems: "center",
                                        width: "100%",
                                    }}>

                                        <span className="mt-5" onClick={() => history.push('/Contacts/SaveContact?ID=' + contactID)} style={{
                                            marginLeft: "10px",
                                            paddingTop: "2px",
                                            cursor: "pointer",
                                            paddingLeft: "14px",
                                            fontSize: "14px",
                                            fontWeight: "700",
                                            lineHeight: "1.4"
                                        }}>
                                            {name} {" "}

                                        </span>
                                        <span
                                            style={{
                                                cursor: "pointer",
                                                position: "relative",
                                                marginLeft: "auto",
                                                paddingRight: "10px"
                                            }}
                                        >
                                            {/* {
                                        isCheckFieldsAvailable(emailAddress, phoneNumber, diary) && */}
                                            <i className="fa fa-ellipsis-v m-10 ellipsis-round" onClick={() => toggleContextMenu(contactID)}></i>
                                            {/* }
                                    {
                                        !isCheckFieldsAvailable(emailAddress, phoneNumber, diary) &&
                                        <i className="fa fa-ellipsis-v m-10 ellipsis-round" style={{ color: "#6F6F6F", cursor: "not-allowed" }}></i>
                                    } */}

                                        </span>

                                    </div>
                                    {companyName && companyName != null && companyName != "" &&
                                        <div style={{
                                            marginTop: "-10px",
                                            marginBottom: viewType == VIEW_TYPE.CARD_SUMMARY ? "10px" : "0px",
                                            display: "flex",
                                            marginLeft: "23px"
                                        }}>

                                            <span
                                                onClick={() => history.push('/Contacts/SaveContact?ID=' + contactID)}
                                                className="company"
                                                style={{
                                                    cursor: "pointer"
                                                }}>
                                                {companyName}
                                            </span>
                                        </div>
                                    }
                                    {contactItem.contactID === clickedContactId && (
                                        <div
                                            ref={menuRef}
                                            className="context-menu"
                                            style={{
                                                top: '30px',
                                                width: '270px',
                                                zIndex: 10,
                                                ...dropdownPosition === 'left' ? { left: 320 } : { right: 35 },
                                            }}

                                        >
                                            {/* Contact Information */}


                                            {phoneNumber !== "" && <>
                                                <div
                                                    className="context-menu-link"
                                                    onClick={() => onWhatsappClick(dialingCode + phoneNumber)}
                                                >
                                                    <i className="fa fa-whatsapp"
                                                    ></i>
                                                    <span style={{ fontWeight: "normal" }}>{phoneNumber}</span>

                                                </div>
                                            </>}


                                            {emailAddress &&

                                                <div
                                                    className="context-menu-link"
                                                    onClick={() => onClickSendEmail(emailAddress)}>
                                                    <i className="fa fa-envelope-o"></i>
                                                    <span title={emailAddress}>
                                                        {emailAddress}
                                                    </span>

                                                </div>
                                            }

                                            <div
                                                className="context-menu-link"
                                                onClick={onClickNewDiary}
                                            >
                                                <i className="fa fa-calendar"></i>
                                                <span>New activity</span>
                                            </div>
                                            <div
                                                className="context-menu-link"
                                                onClick={handleClickSendPipeline}
                                                style={{
                                                    backgroundColor: filteredPipeline
                                                        && filteredPipeline.length > 0
                                                        && isSendPipelineMenu && '#D3D3D3',

                                                }}>
                                                <i className="fa fa-paper-plane-o"></i>
                                                <span>
                                                    Send To
                                                </span>

                                            </div>
                                            {/* Send To Pipeline Menu */}

                                            {contactItem.contactID === clickedContactId
                                                && isSendPipelineMenu
                                                && (
                                                    <div
                                                        ref={pipelineMenuRef}
                                                        className="context-menu"
                                                        style={{
                                                            top: '0px',
                                                            width: '240px',
                                                            ...dropdownPosition === 'left' ? { left: 265 } : { right: 260 },


                                                        }}

                                                    >

                                                        {filteredPipeline.map((pipeline, index) => {
                                                            return (
                                                                <>
                                                                    {pipeline.stages && pipeline.stages.length > 0
                                                                        && (
                                                                            <>
                                                                                <div
                                                                                    className="context-menu-link"
                                                                                    onClick={() => { handleClickPipeline(pipeline.pipeline_id) }}
                                                                                    style={{
                                                                                        backgroundColor: clickedPipelineId === pipeline.pipeline_id && "#D3D3D3"
                                                                                    }}>
                                                                                    <i className="fa fa-list-alt" style={{ fontSize: "14px" }}></i>
                                                                                    <span key={index}>
                                                                                        {pipeline.pipeline_name}
                                                                                    </span>
                                                                                </div>
                                                                            </>
                                                                        )
                                                                    }

                                                                    {
                                                                        pipeline.stages && pipeline.stages.length === 0 &&
                                                                        (
                                                                            <>
                                                                                <div
                                                                                    title="No milestone available"
                                                                                    style={{
                                                                                        color: "gray",
                                                                                        cursor: "not-allowed",
                                                                                    }}
                                                                                    className="context-menu-link">
                                                                                    <i className="fa fa-list-alt" style={{ fontSize: "14px" }}></i>
                                                                                    <span key={index}>
                                                                                        {pipeline.pipeline_name}
                                                                                    </span>
                                                                                </div>
                                                                            </>
                                                                        )
                                                                    }



                                                                </>


                                                            )
                                                        })
                                                        }
                                                    </div>
                                                )}

                                            {/* Send To Stage Menu */}

                                            {contactItem.contactID === clickedContactId
                                                && isSendStageMenu
                                                && (
                                                    <>


                                                        <div
                                                            //ref={pipelineMenuRef}
                                                            className="context-menu"
                                                            style={{
                                                                top: '0',
                                                                width: '200px',
                                                                ...dropdownPosition === 'left' ? { left: 465 } : { right: 460 },


                                                            }}

                                                        >


                                                            {filteredMilestone && filteredMilestone.length > 0 && filteredMilestone.map((stage, index) => {
                                                                return (
                                                                    <>

                                                                        <div
                                                                            onClick={() => { handleMilestoneClick(stage.stage_id) }}
                                                                            className="context-menu-link"
                                                                        >
                                                                            <i className="fa fa-list" style={{ fontSize: "12px" }}></i>
                                                                            <span key={index} style={{ marginLeft: "5px" }}>
                                                                                {stage.stage_name}
                                                                            </span>
                                                                        </div>
                                                                    </>


                                                                )
                                                            })
                                                            }

                                                        </div>
                                                    </>
                                                )}

                                            {/* Activity Note */}
                                            {
                                                diary !== null && diary.description && Object.keys(diary).length > 0 &&
                                                <div
                                                    style={{
                                                        padding: '10px',
                                                        backgroundColor: '#FFFBCC',
                                                        borderRadius: '5px',
                                                        cursor: "text"
                                                    }}>

                                                    <div
                                                        style={{
                                                            display: 'flex',
                                                            alignItems: 'center',
                                                            marginBottom: '5px',

                                                        }}>
                                                        <i

                                                            className="fa fa-thumb-tack"
                                                            style={{
                                                                fontSize: "14px",
                                                                marginTop: "10px"
                                                            }}
                                                        ></i>
                                                        <span style={{
                                                            marginLeft: "20px",
                                                            fontSize: "14px"
                                                        }}>
                                                            {
                                                                diary?.startDate
                                                                && diary?.startDate != null
                                                                && diary?.startDate != ""
                                                                && getDiaryTime(diary?.startDate)
                                                            }
                                                            {
                                                                diary?.endDate
                                                                && diary?.endDate != null
                                                                && diary?.endDate != ""
                                                                && " - " + getDiaryTime(diary?.endDate)
                                                            }
                                                        </span>
                                                    </div>
                                                    <div style={{
                                                        marginLeft: "28px"
                                                    }}>
                                                        <strong>{diary?.typeID}</strong>
                                                        <p style={{
                                                            fontWeight: "normal",
                                                            fontSize: "14px"
                                                        }}>
                                                            {
                                                                diary?.startDate
                                                                && diary?.startDate != null
                                                                && diary?.startDate != ""
                                                                && getDiaryDate(diary?.startDate)
                                                            }
                                                            {
                                                                diary?.endDate
                                                                && diary?.endDate != null
                                                                && diary?.endDate != ""
                                                                && " - " + getDiaryDate(diary?.endDate)
                                                            }
                                                        </p>
                                                        {
                                                            diary?.description != "" && <p style={{ fontWeight: "normal" }}>{diary?.description}</p>
                                                        }

                                                    </div>
                                                </div>
                                            }

                                        </div>
                                    )}


                                </div>
                            </div>
                        </div>
                    </>
                }


                {viewType == VIEW_TYPE.CARD_FULL && (
                    <>

                        <div className="card-body">
                            <div style={{
                                display: "flex",
                                marginTop: companyName && companyName != "" ? "8px" : "0px",
                                marginLeft: "5px"
                            }}>
                                {
                                    diary === null && lastActivity !== "" && (
                                        <>
                                            <i title="Last contact time" className="fa fa-clock-o time-calender ml-5 mr-5" aria-hidden="true" style={{ cursor: "default" }}></i>
                                            <p>{lastActivity}</p>
                                        </>)
                                }
                                {
                                    diary !== null && Object.keys(diary).length > 0 && (
                                        <>
                                            <div style={{
                                                display: "flex",
                                                flexDirection: "column"
                                            }}>
                                                <div style={{
                                                    display: "flex",
                                                    marginTop: companyName && companyName != "" ? "10px" : "0px"
                                                }}>
                                                    <i className="fa fa-calendar time-calender ml-5 mr-5" aria-hidden="true"></i>
                                                    <p>{diary.startDate}</p>
                                                    <span style={{ marginLeft: "8px" }}>
                                                        <b>
                                                            {diary.typeID}
                                                        </b>

                                                    </span>
                                                </div>
                                                {/* <div style={{
                                                    display: "flex",

                                                }}>


                                                </div> */}
                                            </div>





                                        </>)
                                }

                            </div>
                        </div>

                        {/* Labels moved outside card-body */}
                        {
                            tags && tags.length > 0 && (
                                <div className="card-labels">
                                    {tagColorFormatter(tags)}
                                </div>
                            )
                        }
                        {requirementOrLead && requirementOrLead !== "" &&
                            <div className="card-footer">
                                <p>
                                    <a onClick={handleClickExternalLink}>
                                        <i class="fa fa-external-link" style={{ color: "black", cursor: "pointer", fontSize: "14px", marginRight: "5px" }} aria-hidden="true"></i>
                                    </a>
                                    {leadRequirementFormatter(requirementOrLead)}

                                </p>
                            </div>
                        }
                    </>
                )}
            </div >
        </>);
})
export default ContactCard;